import React from 'react';
import { UserIcon as HeroUserIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type UserIconProps = Omit<IconProps, 'children'>;

export const UserIcon: React.FC<UserIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroUserIcon />
        </Icon>
    );
};
